import { render } from "./UserAuth.vue?vue&type=template&id=d3925322&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=d3925322&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3925322"

export default script